import _ from 'lodash';
import {
  AllegroCreateOrUpdateReturnPolicyRequest,
  AllegroReturnPolicyAddress,
  AllegroReturnPolicyAvailability,
  AllegroReturnPolicyAvailabilityRange,
  AllegroReturnPolicyContact,
  AllegroReturnPolicyOptions,
  AllegroReturnPolicyRestrictionCause,
  AllegroReturnPolicyReturnCost,
} from '../../../../../api/allegro/returnpolicy/returnPolicyTypes';
import { Edit } from './returnPolicyState';

function mapRestrictionCause(edit: Edit): AllegroReturnPolicyRestrictionCause | undefined {
  if (edit.range === AllegroReturnPolicyAvailabilityRange.FULL) {
    return undefined;
  }

  const restrictionCause = {
    name: edit.restrictionCauseName ?? undefined,
    description: edit.restrictionCauseDescription || undefined,
  };

  if (_.every(restrictionCause, _.isUndefined)) {
    return undefined;
  }

  return restrictionCause;
}

function mapAvailability(edit: Edit): AllegroReturnPolicyAvailability {
  return {
    range: edit.range as AllegroReturnPolicyAvailabilityRange,
    restrictionCause: mapRestrictionCause(edit),
  };
}

function mapReturnCost(edit: Edit): AllegroReturnPolicyReturnCost | undefined {
  if (!edit.coveredBy) {
    return undefined;
  }
  return { coveredBy: edit.coveredBy };
}

function mapAddress(edit: Edit): AllegroReturnPolicyAddress | undefined {
  const address = {
    name: edit.name || undefined,
    street: edit.street || undefined,
    postCode: edit.postCode || undefined,
    city: edit.city || undefined,
    countryCode: edit.countryCode || undefined,
  };

  if (_.every(address, _.isUndefined)) {
    return undefined;
  }

  return address as AllegroReturnPolicyAddress;
}

function mapContact(edit: Edit): AllegroReturnPolicyContact | undefined {
  const contact = {
    email: edit.email || undefined,
    phoneNumber: edit.phoneNumber || undefined,
  };

  if (_.every(contact, _.isUndefined)) {
    return undefined;
  }

  return contact;
}

function mapOptions(edit: Edit): AllegroReturnPolicyOptions {
  return {
    cashOnDeliveryNotAllowed: edit.cashOnDeliveryNotAllowed,
    freeAccessoriesReturnRequired: edit.freeAccessoriesReturnRequired,
    refundLoweredByReceivedDiscount: edit.refundLoweredByReceivedDiscount,
    businessReturnAllowed: edit.businessReturnAllowed,
    collectBySellerOnly: edit.collectBySellerOnly,
  };
}

export default function mapRequest(edit: Edit): AllegroCreateOrUpdateReturnPolicyRequest {
  return {
    name: edit.label,
    availability: mapAvailability(edit),
    withdrawalPeriod: edit.withdrawalPeriod || undefined,
    returnCost: mapReturnCost(edit),
    address: mapAddress(edit),
    contact: mapContact(edit),
    options: mapOptions(edit),
  };
}
